import { z } from "zod"

export const editUserSchema = z.object({
  country: z.string().min(1, { message: "El país es obligatorio" }),
  gifted: z.boolean().optional().default(false),
  lives: z.number().int("Debe ser un número entero").min(0, "Debe ser un número no negativo"),
})

export type EditUserSchema = z.infer<typeof editUserSchema>
